import { useInfiniteQuery } from '@tanstack/react-query';
import { getPopular } from '../api/popular/getPopular';

type Params = Parameters<typeof getPopular>[0];

export const useGetPopular = (params: Params) => {
  return useInfiniteQuery({
    queryFn: ({ pageParam }) => getPopular({ ...params, paged: pageParam }),
    queryKey: ['getPopular', params],
    initialPageParam: params.paged ?? 1,
    getNextPageParam: (lastPage, _, lastPageParam) =>
      lastPage.photos?.length ? lastPageParam + 1 : null,
    getPreviousPageParam: (_, __, lastPageParam) =>
      lastPageParam === 1 ? null : lastPageParam - 1,
    gcTime: 0,
  });
};

export const getUseGetPopularQueryKey = (params: Params) => [
  'getPopular',
  params,
];
